import { render, staticRenderFns } from "./ModalHistoryAdvisor.vue?vue&type=template&id=a4c5c470&lang=pug&"
import script from "./ModalHistoryAdvisor.vue?vue&type=script&lang=js&"
export * from "./ModalHistoryAdvisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports